// Import Core
import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import { useLocation } from "@reach/router";
// Import Libraries
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { Link } from "gatsby-link";
import { Swiper, SwiperSlide } from "swiper/react";
import {
  Navigation as swiperNavigation,
  Pagination as swiperPagination,
} from "swiper/modules";
// Import Swiper Styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
// Import Components
import Separator from "../../ui/Separator";
import TextButton from "../../ui/buttons/TextButton";
import IconList from "../../ui/IconList";
import Stars from "../../ui/Stars";
import RelatedTripsLocations from "../RelatedTripsLocations";
import Pagination from "../../../components/ui/Pagination";
// Import Utils
import { usePlaceholderImage } from "../../../utils/useRandomPlaceholderImage";
import { renderReactIcon } from "../../../utils/renderReactIcons";
import { getSlug } from "../../../utils/getSlug";
import { getShortDate } from "../../../utils/datetime/getShortDate";
import { getAuthor } from "../../../utils/getAuthor";
import { getCardTagline } from "../../../utils/getCardTagline";
import AccordionCheckbox from "../../ui/AccordionCheckbox";
import { toSentenceCase } from "../../../utils/search/toSentenceCase";
import { navigate } from "gatsby";
import { get, set } from "react-hook-form";
import SortByDropdown from "../../ui/SortByDropdown";
import Button from "../../ui/buttons/Button";
import dayjs from "dayjs";
var advancedFormat = require("dayjs/plugin/advancedFormat");
dayjs.extend(advancedFormat);

const isBrowser = typeof window !== "undefined";

const ArchivePageStyling = styled.section`
  display: flex;
  max-width: 1440px;
  width: 100%;
  margin: 0 auto;
  padding: 80px 0;
  /* padding: 80px 64px; */
  flex-direction: column;
  align-items: center;
  gap: 64px;
  background-color: var(--white);
  @media (max-width: 1570px) {
    padding: 80px 64px;
  }

  @media (max-width: 992px) {
    padding: 40px 20px;
    gap: 32px;
  }
  .section-title {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 24px;
    width: 100%;
  }
  .search-wrapper {
    display: flex;
    width: 100%;
    padding: 40px 0 80px;
    align-items: flex-start;
    gap: 64px;
    position: relative;
    @media (max-width: 1200px) {
    }
    @media (max-width: 992px) {
      flex-direction: column;
      padding: 24px 0 0;
      gap: 20px;
    }
    .sidebar {
      display: flex;
      max-width: 290px;
      flex-direction: column;
      align-items: flex-start;
      gap: 24px;
      min-width: 288px;
      /* position: sticky;
			top: 200px; */

      @media (max-width: 992px) {
        display: none;
        max-width: unset;
        width: 100%;
        position: unset;
        gap: 32px;
      }
      /* TODO:  SHOW ONCE FILTERS ARE DONE */
      /* display: none; */
      .sidebar-heading {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        .sidebar-heading-title {
          text-transform: uppercase;
          font-family: var(--font-family-heading);
        }
        .clear-all-btn {
          color: var(--neutral-25);
          text-transform: uppercase;
          font-family: var(--font-family-heading);
        }
      }
      .accordion {
        width: 100%;
      }
    }
    .mobile-filters {
      display: none;
      @media (max-width: 992px) {
        display: block;
        width: 100%;
        & button {
          width: 100%;
        }
      }
    }
    .mobile-filers-wrapper {
      z-index: 999;
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: var(--white);
      padding: 16px 0;
      .heading {
        font-size: 24px;
        line-height: 28px;
        color: var(--black);
        margin-bottom: 24px;
        padding: 0 16px;
      }
      p.small {
        padding: 16px;
        padding-top: 0;
      }
    }
    .close-filters {
      padding: 0 16px;
      display: flex;
      justify-content: flex-end;
      cursor: pointer;
    }
    .dropdowns-wrapper {
      max-height: 75dvh;
      overflow-y: scroll;
      padding: 0 16px;
    }
    .results-wrapper {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 24px;
      flex: 1 0 0;
      .result-wrapper-header {
        display: flex;
        justify-content: space-between;
        width: 100%;
        @media (max-width: 992px) {
          flex-direction: column-reverse;
          gap: 16px;
        }
      }
      .current-search-tags {
        display: flex;
        align-items: flex-end;
        flex-wrap: wrap;
        flex-direction: row;
        gap: 10px;
      }
      .tag-wrapper {
        padding: 2px 4px 2px 8px;
        background-color: var(--grey-10);
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        font-size: 16px;
        line-height: 24px;
      }
      .reset-tag {
        display: flex;
        cursor: pointer;
        padding: 4px;
      }
      .results {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 24px;
        width: 100%;
        .card-wrapper {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          gap: 36px;
          align-self: stretch;
          .card {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            gap: 16px;
            width: 100%;
            .card-title {
              display: flex;
              padding-right: 16px;
              justify-content: flex-end;
              align-items: flex-end;
              gap: 10px;
              align-self: stretch;
              @media (max-width: 992px) {
                flex-direction: column;
                align-items: flex-start;
                justify-content: center;
              }
              .left {
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                gap: 16px;
                flex: 1 0 0;
                .tagline {
                }
              }
              .right {
                @media (max-width: 768px) {
                  width: 100%;
                }
                .price {
                  color: var(--blue);
                }
                .ratings {
                  display: flex;
                  gap: 16px;
                  .star-rating {
                    display: flex;
                    justify-content: flex-end;
                    .star {
                      width: 18.5px;
                      height: 17.6px;
                    }
                  }
                  .hotel-type {
                    text-transform: capitalize;
                  }
                }
                .review-info {
                  display: flex;
                  gap: 8px;
                  flex-direction: column;
                  align-items: flex-end;
                  flex-wrap: wrap;
                  @media (max-width: 992px) {
                    align-items: center;
                    justify-content: space-between;
                    flex-direction: row-reverse;
                  }
                  .published-date {
                    color: var(--neutral-75);
                  }
                  .author {
                    color: var(--neutral-75);
                    span {
                      color: var(--red);
                    }
                  }
                }
                .related {
                  margin-top: 16px;
                }
              }
            }
            .image-text-content {
              width: inherit;
              display: flex;
              padding-right: 16px;
              align-items: flex-start;
              gap: 32px;
              @media (max-width: 1200px) {
                flex-wrap: wrap;
                padding-right: 0px;
              }
              @media (max-width: 992px) {
                flex-direction: column;

                gap: 24px;
              }
              .img-slider-wrapper {
                width: 280px;
                @media (max-width: 992px) {
                  width: 100%;
                }
                .swiper {
                  .swiper-button-prev,
                  .swiper-button-next {
                    background-color: var(--red);
                    width: 32px;
                    height: 32px;
                    padding: 9px 0px;
                    &:after {
                      color: var(--white);
                      font-size: 12px;
                      font-style: normal;
                      font-weight: 900;
                      line-height: 150%;
                    }

                    &:hover {
                      background-color: var(--red-110);
                    }
                    &.swiper-button-disabled {
                      display: none;
                    }
                  }
                  .swiper-pagination {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    gap: 8px;
                    padding: 8px 16px;
                    margin: 0;
                    z-index: 1;
                    .swiper-pagination-bullet {
                      width: 8px;
                      height: 8px;
                      border-radius: 0;
                      opacity: 1;
                      background-color: var(--neutral-50);
                      &.swiper-pagination-bullet-active {
                        background-color: var(--white);
                      }
                    }
                  }
                }
              }

              .gatsby-image-wrapper-constrained,
              .placeholder-img {
                width: 280px;
                height: 280px;
                @media (max-width: 992px) {
                  /* width: 50%; */
                  width: 100%;
                }
              }
              img {
                display: block;
                /* width: 280px;
                height: 280px; */
                object-fit: cover;
              }
              .content {
                width: inherit;
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                flex: 1 0 0;
                padding-top: 16px;
                gap: 16px;
                .special-offer {
                  .offer {
                    color: var(--blue);
                    .badge {
                      padding: 4px 8px;
                      margin: 0 8px 0 -5px;
                      border-radius: 4px;
                      background: var(--blue-75);
                      color: var(--white);
                    }
                  }
                }
              }
              .includes {
                max-width: 175px;
                display: flex;
                padding-bottom: 16px;
                flex-direction: column;
                align-items: flex-start;
                padding-left: 32px;
                border-left: 1px solid var(--neutral-10);
                /* gap: 8px; */
                /* align-self: stretch; */
                flex-shrink: 1;
                @media (max-width: 1200px) {
                  flex-direction: row;
                  border-left: none;
                  padding-left: 0;
                  max-width: 100%;
                }
                .included-items {
                  display: flex;
                  gap: 16px;
                  align-items: flex-end;
                  position: relative;
                  .icon-list {
                    flex-direction: column;
                    align-items: flex-start;
                    @media (max-width: 1200px) {
                      flex-direction: row;
                    }
                    .icon-list-item {
                      .icon-name {
                        flex: 1 0 0;
                      }
                    }
                    .popover {
                      .popover-wrapper {
                        .popover.popover-top {
                          top: calc(24px * -3.5);
                        }
                      }
                    }
                    .popover-children {
                      .includes-popover {
                        display: flex;
                        height: 24px;
                        padding: 8px;
                        justify-content: center;
                        align-items: center;
                        gap: 8px;
                        border-radius: 4px;
                        background-color: var(--red-10);
                        color: var(--red);
                        position: relative;
                        cursor: pointer;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    .card-price {
      font-size: 24px;
      line-height: 28px;
      font-weight: 700;
      margin-top: 16px;
    }
    .tags-wrapper {
      display: flex;
      width: 100%;
      justify-content: space-between;
      .single-tag-wrapper {
        color: var(--orange-120);
      }
    }
  }
  .red-bg {
    &.card-wrapper {
      .card {
        .card-title {
          .left {
            .copies-wrapper{
              display: flex; 
              gap: 16px;
            }
            .tagline,.highly-recommended{
              z-index: 1;
              padding: 4px 8px;
              border-radius: 4px;
              font-weight: 700;
              font-family: var(--font-family-base-bold);
              font-size: 0.778rem; //14px
            }
            .tagline {
              display: flex;
              align-items: flex-start;
              gap: 8px;
              background: var(--red-light);
              color: var(--red);
            }
             .highly-recommended{
              background: var(--blue-10);
              color: var(--blue);
            }
          }
        }
      }
    }
  }
  .orange-bg {
    .tagline {
      display: flex;
      padding: 4px 8px;
      align-items: flex-start;
      gap: 8px;
      border-radius: 4px;
      background: var(--orange-10);
      color: var(--orange-120);
      font-weight: 700;
      font-family: var(--font-family-base-bold);
      font-size: 0.778rem; //14px
      width: fit-content;
    }
    &.card-wrapper {
      .card {
        .card-title {
          .left {
            .tagline {
              display: flex;
              padding: 4px 8px;
              align-items: flex-start;
              gap: 8px;
              border-radius: 4px;
              background: var(--orange-10);
              color: var(--orange-120);
              font-weight: 700;
              font-family: var(--font-family-base-bold);
              font-size: 0.778rem; //14px
            }
          }
        }
        .image-text-content {
          .includes {
            .included-items {
              .icon-list-item {
                .list-icon {
                  background-color: var(--orange-10);
                  svg {
                    color: var(--orange-110);
                  }
                }
              }
              .popover-children {
                .includes-popover {
                  background-color: var(--orange-10);
                  color: var(--orange);
                }
              }
            }
          }
        }
      }
    }
    .special-offer {
      color: var(--blue-75);
      font-size: 16px;
      line-height: 24px;
      font-weight: 700;
    }
    .month-label {
      padding: 7px;
      background-color: var(--orange-10);
      color: var(--orange-120);
    }
  }
`;

const ArchiveContent = ({
  page,
  results,
  filterableData,
  location,
  sortType = null,
}) => {
  // For pagination
  if (sortType === "date") {
    results.sort((a, b) => {
      const dateA = a?.minDate?.landonlydeparturedate;
      const dateB = b?.minDate?.landonlydeparturedate;
      if (dateA === undefined) return 1;
      if (dateB === undefined) return -1;
      const dateObjA = new Date(dateA);
      const dateObjB = new Date(dateB);
      if (isNaN(dateObjA)) return 1;
      if (isNaN(dateObjB)) return -1;
      return dateObjA - dateObjB;
    });
  } else {
    results.sort((a, b) => a.offerPrice?.localeCompare(b.offerPrice));
  }

  const [archivePageResults, setArchivePageResults] = useState([]);
  // -> Filter
  const [filteredResults, setfilteredResults] = useState(results);
  // -> Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage] = useState(15);

  // console.log("page->", page);
  // console.log("results->", results);
  // console.log("filterableData->", filterableData);

  // Pagination
  const [indexOfLastRecord, setIndexOfLastRecord] = useState(
    currentPage * recordsPerPage
  );
  const [indexOfFirstRecord, setIndexOfFirstRecord] = useState(
    indexOfLastRecord - recordsPerPage
  );
  // Calculate number of pages for pagination
  const [nPages, setNPages] = useState(
    Math.ceil(results.length / recordsPerPage)
  );
  // Update CurrentRecords to split our new array into pages
  const [currentRecords, setCurrentRecords] = useState(
    results.slice(indexOfFirstRecord, indexOfLastRecord)
  );
  // Pagination: update state to show next page results
  // useEffect(() => {
  // 	setArchivePageResults(() => currentRecords);
  // }, [currentPage, archivePageResults]);

  useEffect(() => {
    if (location?.state?.fromSearch) resetAllState();
  }, [location?.state]);

  // TODO:  On filter change - recalculate pagination
  useEffect(() => {
    setIndexOfLastRecord(() => currentPage * recordsPerPage);
    let lastIndex = indexOfLastRecord;
    setIndexOfFirstRecord(() => lastIndex - recordsPerPage);
    // Calculate number of pages for pagination
    let firstIndex = indexOfFirstRecord;
    setNPages(Math.ceil(filteredResults.length / recordsPerPage));
    // Update CurrentRecords to split our new array into pages
    setCurrentRecords(filteredResults.slice(firstIndex, lastIndex));
  }, [filteredResults, indexOfFirstRecord, indexOfLastRecord, currentPage]);

  useEffect(() => {
    let currentRecordsUpdated = currentRecords;
    setArchivePageResults(() => currentRecordsUpdated);
  }, [currentPage, currentRecords]);

  const { randomPlaceholderImage } = usePlaceholderImage();

  /*
   * Accordion with items for each
   * Results items that need to be separate from pagination
   * In each accordion section -
   *	- on click save each item to array of checked items
   *	- Find items that contain any .some()
   * Do this for each - split into array of arrays? e.g. 3 accordion rows checked items = [[], [], []]
   * Find items that feature in each array and show result - pagination need to be redone?
   * Show all results if all boxes unchecked
   * So will need all results to filter each time then return new results
   */

  // TODO:  Pagination will need to be tweaked to account for filter

  const filterCheckboxResults = (checkboxes) => {
    const matchingResults = [];

    checkboxes.length > 0 &&
      checkboxes.forEach((items) => {
        /* Items to filter in accordions
         * Depending on page types:
         * * Countries
         * * Destinations / Cities
         * * Regions
         * * Authors
         * * TODO:  For Short Breaks - need hotel type & star rating
         * *
         */
        if (items) {
          if (items.length > 0 && items[0].type === "Country") {
            const itemsArray = items.map((item) => item.name);

            const matchingCountries = [];
            results.forEach((item) => {
              const countryName = item.country?.name;
              if (countryName && itemsArray.includes(countryName)) {
                matchingCountries.push(item);
              }
            });
            matchingResults.push(matchingCountries);
          }
          if (items.length > 0 && items[0].type === "Countries") {
            const itemsArray = items.map((item) => item.name);

            const matchingCountries = [];
            results.forEach((item) => {
              if (item.includedCountries !== undefined) {
                const countryName = item.includedCountries?.map(
                  (country) => country?.name
                );
                countryName.forEach((country) => {
                  if (country && itemsArray.includes(country)) {
                    matchingCountries.push(item);
                  }
                });
              } else if (
                // This is for hotel breaks or shortbreaks where there is item country rather than includedCountries array
                item.country !== undefined &&
                !item.includedCountries
              ) {
                const countryName = item.country.name;
                if (countryName && itemsArray.includes(countryName)) {
                  matchingCountries.push(item);
                }
              }
            });
            matchingResults.push(matchingCountries);
          }
          if (items.length > 0 && items[0].type === "Destinations") {
            const itemsArray = items.map((item) => item.name);

            const matchingDestinations = [];
            results.forEach((item) => {
              const cityName = item.city?.name;
              if (cityName && itemsArray.includes(cityName)) {
                matchingDestinations.push(item);
              }
            });
            matchingResults.push(matchingDestinations);
          }
          if (items.length > 0 && items[0].type === "Cities") {
            const itemsArray = items.map((item) => item.name);

            const matchingCities = [];
            results.forEach((item) => {
              if (item.includedCities !== undefined) {
                const cityName = item.includedCities?.map((city) => city?.name);
                // console.log("🚀 ~ file: ArchiveContent.js:474 ~ results.forEach ~ cityName:", cityName);
                cityName.forEach((city) => {
                  if (city && itemsArray.includes(city)) {
                    matchingCities.push(item);
                  }
                });
              }
            });
            matchingResults.push(matchingCities);
          }
          if (items.length > 0 && items[0].type === "Regions") {
            const itemsArray = items.map((item) => item.name);

            const matchingRegions = [];
            results.forEach((item) => {
              const regionName = item.region?.name;
              if (regionName && itemsArray.includes(regionName)) {
                matchingRegions.push(item);
              }
            });
            matchingResults.push(matchingRegions);
          }
          if (items.length > 0 && items[0].type === "Authors") {
            const itemsArray = items.map((item) => item.name);
            // console.log(
            // 	'🚀 ~ file: ArchiveContent.js:444 ~ filterCheckboxResults ~ itemsArray:',
            // 	itemsArray
            // );

            const matchingAuthors = [];
            results.forEach((item) => {
              if (item.authorPersonType === "expert") {
                const authorName = item.authorExpert?.title;
                if (authorName && itemsArray.includes(authorName)) {
                  matchingAuthors.push(item);
                }
              } else if (item.authorPersonType === "tourLeader") {
                const authorName = item.authorTourLeader?.title;
                if (authorName && itemsArray.includes(authorName)) {
                  matchingAuthors.push(item);
                }
              } else if (item.authorPersonType === "artist") {
                const authorName = item.authorArtist?.title;
                if (authorName && itemsArray.includes(authorName)) {
                  matchingAuthors.push(item);
                }
              }
              // const cityName = item.city?.name;
              // if (cityName && itemsArray.includes(cityName)) {
              // 	matchingCities.push(item);
              // }
            });
            // console.log({ matchingAuthors });
            matchingResults.push(matchingAuthors);
          }

          // FIX:  For some reason this isn't working
          if (items.length > 0 && items[0].type === "Star Rating") {
            const itemsArray = items.map((item) => item.name);

            const matchingStarRatings = [];
            results.forEach((item) => {
              const starRating = item.starRating;
              // console.log("🚀 ~ file: ArchiveContent.js:549 ~ results.forEach ~ starRating:", starRating);
              if (
                starRating &&
                starRating !== 0 &&
                itemsArray.includes(starRating)
              ) {
                // console.log(itemsArray.includes(starRating), item, item.starRating, starRating);
                matchingStarRatings.push(item);
              }
            });
            matchingResults.push(matchingStarRatings);
          }
          if (items.length > 0 && items[0].type === "Hotel Type") {
            const itemsArray = items.map((item) => item.name);

            const matchingHotelTypes = [];
            results.forEach((item) => {
              const hotelType = item.hotelType;
              if (
                hotelType &&
                hotelType !== "None" &&
                itemsArray.includes(toSentenceCase(hotelType))
              ) {
                matchingHotelTypes.push(item);
              }
            });
            matchingResults.push(matchingHotelTypes);
          }
        }
      });

    // console.log({ matchingResults });
    // Find items that feature in each array
    var result =
      matchingResults.length > 0
        ? matchingResults
          .shift()
          .filter((result) =>
            matchingResults.every((subarray) =>
              subarray.some((el) => el.title === result.title)
            )
          )
        : (result = results);

    // Filter out duplicates
    result = result.filter((value, index, self) => {
      return (
        index ===
        self.findIndex((t) => t.place === value.place && t._id === value._id)
      );
    });

    setfilteredResults(result);
    setCurrentPage(1);
  };

  const [accordionItems, setAccordionItems] = useState([]);
  const [filterDataLoaded, setFilterDataLoaded] = useState(false);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [sortBy, setSortBy] = useState(null);

  const sortByHandler = (value) => {
    setSortBy(value);
  };

  const currentLocation = useLocation();

  const createUrlParamsString = (filterName) => {
    let string = "";
    let arr = [];

    let FILTERS = {
      Destinations: "cities",
      Countries: "countries",
      Country: "countries",
      Themes: "themes",
      Authors: "authors",
      "Star Rating": "stars",
      "Hotel Type": "hotelType",
      Artists: "artists",
      "Tour Leaders": "tourLeaders",
      "Departure Months": "departureMonths",
      Regions: "regions",
      "Holiday Types": "holidayTypes",
    };
    if (accordionItems.find((item) => item.title === filterName)) {
      arr = accordionItems
        .find((item) => item.title === filterName)
        .checkboxes.filter((item) => item.isChecked === true)
        .map((item) =>
          item.name.toLowerCase().replace(/\s/g, "-").replace("&", "and")
        );
      string = arr.length > 0 ? `${FILTERS[filterName]}=${arr.join(",")}` : "";
    }

    return string;
  };
  const setFiltersToUrl = () => {
    if (isBrowser) {
      let urlParams = "";
      let cities = createUrlParamsString("Destinations");
      let countries = createUrlParamsString("Countries");
// commenting out the option of hotelBreak 
/*    let countries =
        page.cptType === "hotelBreak"
          ? createUrlParamsString("Country")
          : createUrlParamsString("Countries"); */
      let themes = createUrlParamsString("Themes");
      let authors = createUrlParamsString("Authors");
      let stars = createUrlParamsString("Star Rating");
      let hotelType = createUrlParamsString("Hotel Type");
      let artists = createUrlParamsString("Artists");
      let tourLeaders = createUrlParamsString("Tour Leaders");
      let departureDates = createUrlParamsString("Departure Months");
      let regions = createUrlParamsString("Regions");
      let holidayTypes = createUrlParamsString("Holiday Types");

      if (window.location.search.startsWith("?value=")) {
        urlParams = `?value=${window.location.search
          .split("&")
          .find((el) => el.includes("value="))
          .split("=")
          .slice(1)}`;
        urlParams += cities !== "" ? `&${cities}` : "";
        urlParams += countries !== "" ? `&${countries}` : "";
        urlParams += themes !== "" ? `&${themes}` : "";
        urlParams += authors !== "" ? `&${authors}` : "";
        urlParams += stars !== "" ? `&${stars}` : "";
        urlParams += hotelType !== "" ? `&${hotelType}` : "";

        urlParams += artists !== "" ? `&${artists}` : "";
        urlParams += tourLeaders !== "" ? `&${tourLeaders}` : "";
        urlParams += departureDates !== "" ? `&${departureDates}` : "";
        urlParams += regions !== "" ? `&${regions}` : "";
        urlParams += holidayTypes !== "" ? `&${holidayTypes}` : "";
      } else {
        urlParams += cities !== "" ? `?${cities}` : "";
        urlParams +=
          countries !== "" ? `${cities !== "" ? "&" : "?"}${countries}` : "";
        urlParams +=
          themes !== ""
            ? `${cities !== "" || countries !== "" ? "&" : "?"}${themes}`
            : "";
        urlParams +=
          authors !== "" ? `${themes !== "" ? "&" : "?"}${authors}` : "";

        urlParams +=
          stars !== ""
            ? `${cities !== "" || countries !== "" ? "&" : "?"}${stars}`
            : "";
        urlParams +=
          hotelType !== ""
            ? `${
                cities !== "" || countries !== "" || stars !== "" ? "&" : "?"
            }${hotelType}`
            : "";

        urlParams +=
          artists !== ""
            ? `${
                hotelType !== "" ||
              cities !== "" ||
              countries !== "" ||
              stars !== ""
              ? "&"
              : "?"
            }${artists}`
            : "";

        urlParams +=
          tourLeaders !== ""
            ? `${
                artists !== "" ||
              hotelType !== "" ||
              cities !== "" ||
              countries !== "" ||
              stars !== ""
              ? "&"
              : "?"
            }${tourLeaders}`
            : "";

        urlParams +=
          departureDates !== ""
            ? `${
                tourLeaders !== "" ||
              artists !== "" ||
              hotelType !== "" ||
              cities !== "" ||
              countries !== "" ||
              stars !== ""
              ? "&"
              : "?"
            }${departureDates}`
            : "";

        urlParams +=
          regions !== ""
            ? `${
                departureDates !== "" ||
              tourLeaders !== "" ||
              artists !== "" ||
              hotelType !== "" ||
              cities !== "" ||
              countries !== "" ||
              stars !== ""
              ? "&"
              : "?"
            }${regions}`
            : "";
        urlParams +=
          holidayTypes !== ""
            ? `${
                regions !== "" ||
              departureDates !== "" ||
              tourLeaders !== "" ||
              artists !== "" ||
              hotelType !== "" ||
              cities !== "" ||
              countries !== "" ||
              stars !== ""
              ? "&"
              : "?"
            }${holidayTypes}`
            : "";
      }
      // navigate(`${window.location.pathname}${urlParams}`);
      window.history.pushState(
        {},
        "",
        `${currentLocation.pathname}${urlParams}`
      );
      // location.search = `?page=${val}`
    }
  };

  const getFilterFromUrl = () => {
    if (isBrowser) {
      if (window.location.search !== "" && accordionItems.length > 0) {
        let FILTERS = {
          cities: "Destinations",
          countries: "Countries",
          country: "Country",
          themes: "Themes",
          authors: "Authors",
          stars: "Star Rating",
          hotelType: "Hotel Type",
          artists: "Artists",
          tourLeaders: "Tour Leaders",
          departureMonths: "Departure Months",
          regions: "Regions",
          holidayTypes: "Holiday Types",
        };

        let splitedByType = window.location.search.split("&");
        let arr = [...accordionItems];

        splitedByType.forEach((item) => {
          if (item.includes("=")) {
            let type = item.split("=")[0];
            let value = item.split("=")[1];
            let valueArray = value.split(",");
            let typeArray = type.split("=");
            let typeString = typeArray[0].replace("?", "");

            if (typeString !== "value") {
              arr
                .find((el) => el.title === FILTERS[typeString])
                .checkboxes.forEach((checkbox) => {
                  if (
                    valueArray.includes(
                      checkbox.name
                        .toLowerCase()
                        .replace(/\s/g, "-")
                        .replace("&", "and")
                    )
                  ) {
                    checkbox.isChecked = true;
                  }
                });
            }
          }
        });

        setAccordionItems(arr);
        setIsInitialLoad(false);
      }
    }
  };

  useEffect(() => {
    if (!filterDataLoaded && filterableData && filterableData.length > 0) {
      setAccordionItems(filterableData);
      setFilterDataLoaded(true);
    }
  }, [filterableData]);

  useEffect(() => {
    let hasSearchParams = window.location.search !== "";
    let hasSelectedCheckboxes = accordionItems.some((item) =>
      item.checkboxes.some((checkbox) => checkbox.isChecked === true)
    );
    if (hasSearchParams && !hasSelectedCheckboxes && isInitialLoad) {
      getFilterFromUrl();
      return;
    }
    if (accordionItems.length > 0 && filterDataLoaded) setFiltersToUrl();
    else getFilterFromUrl();
  }, [accordionItems]);

  const resetAllFilters = () => {
    setAccordionItems((prevItems) =>
      prevItems.map((item, i) => ({
        ...item,
        checkboxes: item.checkboxes.map((checkbox) => ({
          ...checkbox,
          isChecked: false,
        })),
      }))
    );
    setfilteredResults(results);
    setCurrentPage(1);
    // navigate(`${window.location.pathname}`);
    window.history.pushState({}, "", `${currentLocation.pathname}`);
  };

  const toggleAccordion = (index) => {
    // console.log('toggle', index)
    setAccordionItems((prevItems) =>
      prevItems.map((item, i) => ({
        ...item,
        isOpen: i === index ? !item.isOpen : item.isOpen,
      }))
    );
  };
  const [checkIndex, setCheckIndex] = useState(0);
  const [itemIndex, setItemIndex] = useState(0);
  const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
  
  // state for collecting selectedDeparture dates 
  const [selectedDeparture, setSelectedDeparture] = useState([]);
  useEffect(() => {
    // for each accordion item we set an empty array in selectedCheckboxes so we can add / remove items for filtering
    setSelectedCheckboxes(accordionItems.map((item) => []));
  }, []);

  const handleCheckboxChangeAndLog = (itemIndex, checkboxIndex) => {
    // console.log("🚀 ~ file: ArchiveContent.js:440 ~ handleCheckboxChangeAndLog ~ itemIndex, checkboxIndex:", itemIndex, checkboxIndex, accordionItems[itemIndex].checkboxes[checkboxIndex].name);
    setCheckIndex(checkboxIndex);
    setItemIndex(itemIndex);
    setAccordionItems((prevItems) =>
      prevItems.map((item, i) => ({
        ...item,
        checkboxes:
          i === itemIndex
            ? item.checkboxes.map((checkbox, j) =>
              j === checkboxIndex
                ? { ...checkbox, isChecked: !checkbox.isChecked }
                : checkbox
            )
            : item.checkboxes,
      }))
    );

    // check if item exists in selectedCheckboxes - if it does then remove, if it doesn't then add - javascript please
    // const itemPosition = `${itemIndex}${checkboxIndex}`
    const newItem = {
      name: accordionItems[itemIndex].checkboxes[checkboxIndex].name,
      itemPosition: itemIndex,
      checkboxPosition: checkboxIndex,
      type: accordionItems[itemIndex].title,
    };
    // console.log("🚀 ~ file: ArchiveContent.js:482 ~ handleCheckboxChangeAndLog ~ itemPosition:", itemPosition);
    // console.log("🚀 ~ file: ArchiveContent.js:483 ~ handleCheckboxChangeAndLog ~ newItem:", newItem);

    // Check if newItem exists in selectedCheckboxes
    const itemIndexToFind = selectedCheckboxes.findIndex((group) =>
      group?.some(
        (checkbox) =>
          checkbox.name === newItem.name &&
          checkbox.itemPosition === newItem.itemPosition &&
          checkbox.checkboxPosition === newItem.checkboxPosition
      )
    );

    if (itemIndexToFind !== -1) {
      // If newItem exists, remove it
      const updatedCheckboxes = selectedCheckboxes.map((group, index) =>
        index === itemIndexToFind
          ? group.filter(
            (checkbox) =>
              !(
                checkbox.name === newItem.name &&
                checkbox.itemPosition === newItem.itemPosition &&
                checkbox.checkboxPosition === newItem.checkboxPosition
              )
          )
          : group
      );
      setSelectedCheckboxes(updatedCheckboxes);
      // time to filter!
      filterCheckboxResults(updatedCheckboxes);
    } else {
      // If newItem doesn't exist, add it to the corresponding itemPosition
      const updatedCheckboxes = [...selectedCheckboxes];
      updatedCheckboxes[newItem.itemPosition] = [
        ...(updatedCheckboxes[newItem.itemPosition] || []),
        newItem,
      ];
      setSelectedCheckboxes(updatedCheckboxes);
      // time to filter!
      filterCheckboxResults(updatedCheckboxes);
    }
  };

  const [testResults, setTestResults] = useState(results);

  const testFilterFunction = () => {
    let fullResultArr = [...results];
    let filteredResultArr = [];

    let selectedHotelTypes =
      accordionItems.find((el) => el.title === "Hotel Type") !== undefined &&
      accordionItems
        .find((el) => el.title === "Hotel Type")
        .checkboxes.filter((el) => el.isChecked === true)
        .map((el) => el.name.toLowerCase());

    let selectedStars =
      accordionItems.find((el) => el.title === "Star Rating") !== undefined &&
      accordionItems
        .find((el) => el.title === "Star Rating")
        .checkboxes.filter((el) => el.isChecked === true)
        .map((el) => el.name);

    let selectedCountries;
    selectedCountries =
      accordionItems.find((el) => el.title === "Countries") !== undefined &&
      accordionItems
        .find((el) => el.title === "Countries")
        .checkboxes.filter((el) => el.isChecked === true)
        .map((el) => el.name);

// Commenting out hotelBreak option
/*     if (page.cptType === "hotelBreak") {
      selectedCountries =
        accordionItems.find((el) => el.title === "Country") !== undefined &&
        accordionItems
          .find((el) => el.title === "Country")
          .checkboxes.filter((el) => el.isChecked === true)
          .map((el) => el.name);
    } else {
      selectedCountries =
        accordionItems.find((el) => el.title === "Countries") !== undefined &&
        accordionItems
          .find((el) => el.title === "Countries")
          .checkboxes.filter((el) => el.isChecked === true)
          .map((el) => el.name);
    } */

    let selectedCities =
      accordionItems.find((el) => el.title === "Destinations") !== undefined &&
      accordionItems
        .find((el) => el.title === "Destinations")
        .checkboxes.filter((el) => el.isChecked === true)
        .map((el) => el.name);

    let selectedThemes =
      accordionItems.find((el) => el.title === "Themes") !== undefined &&
      accordionItems
        .find((el) => el.title === "Themes")
        .checkboxes.filter((el) => el.isChecked === true)
        .map((el) => el.name);

    let selectedAuthors =
      accordionItems.find((el) => el.title === "Authors") !== undefined &&
      accordionItems
        .find((el) => el.title === "Authors")
        .checkboxes.filter((el) => el.isChecked === true)
        .map((el) => el.name);

    let selectedRegions =
      accordionItems.find((el) => el.title === "Regions") !== undefined &&
      accordionItems
        .find((el) => el.title === "Regions")
        .checkboxes.filter((el) => el.isChecked === true)
        .map((el) => el.name);

    let selectedHolidayTypes =
      accordionItems.find((el) => el.title === "Holiday Types") !== undefined &&
      accordionItems
        .find((el) => el.title === "Holiday Types")
        .checkboxes.filter((el) => el.isChecked === true)
        .map((el) => el.name);

    let selectedDepartureMonths =
      accordionItems.find((el) => el.title === "Departure Months") !==
      undefined &&
      accordionItems
        .find((el) => el.title === "Departure Months")
        .checkboxes.filter((el) => el.isChecked === true)
        .map((el) => el.name);

    // if any date is selected from departure month checkbox, save the dates to the state 
    if(selectedDepartureMonths && selectedDepartureMonths.length > 0){
      setSelectedDeparture(selectedDepartureMonths)
    } else {
      setSelectedDeparture([])
    }
  
    let selectedArtists =
      accordionItems.find((el) => el.title === "Artists") !== undefined &&
      accordionItems
        .find((el) => el.title === "Artists")
        .checkboxes.filter((el) => el.isChecked === true)
        .map((el) => el.name);
  
    let selectedTourLeaders =
      accordionItems.find((el) => el.title === "Tour Leaders") !== undefined &&
      accordionItems
        .find((el) => el.title === "Tour Leaders")
        .checkboxes.filter((el) => el.isChecked === true)
        .map((el) => el.name);
  
    if (selectedCountries.length > 0) {
      if (
        page.cptType === "hotelBreak" ||
        page.cptType === "opera" ||
        page.cptType === "attraction"
      ) {
        filteredResultArr = fullResultArr.filter((item) => {
          if (item.country !== undefined) {
            if (selectedCountries.includes(item.country.name)) {
              return item;
            }
          }
        });
      } else {
        filteredResultArr = fullResultArr.filter((item) => {
          if (item.includedCountries !== undefined) {
            if (
              item.includedCountries.some((country) =>
                selectedCountries.includes(country.name)
              )
            ) {
              return item;
            }
          }
        });
      }
    } else {
      filteredResultArr = fullResultArr; //
    }

    if (selectedHotelTypes.length > 0) {
      filteredResultArr = filteredResultArr.filter((item) => {
        if (item.hotelType !== undefined) {
          if (selectedHotelTypes.includes(item.hotelType.toLowerCase())) {
            return item;
          }
        }
      });
    }

    if (selectedStars.length > 0) {
      filteredResultArr = filteredResultArr.filter((item) => {
        if (item.starRating !== undefined) {
          if (selectedStars.includes(item.starRating)) {
            return item;
          }
        }
      });
    }

    if (selectedCities.length > 0) {
      if (
        page.cptType === "hotelBreak" ||
        page.cptType === "opera" ||
        page.cptType === "attraction"
      ) {
        filteredResultArr = filteredResultArr.filter((item) => {
          if (item.city !== undefined) {
            if (selectedCities.includes(item.city.name)) {
              return item;
            }
          }
        });
      } else {
        filteredResultArr = filteredResultArr.filter((item) => {
          if (item.includedCities !== undefined) {
            if (
              item.includedCities.some((city) =>
                selectedCities.includes(city.name)
              )
            ) {
              return item;
            }
          }
        });
      }
    }
  
    if (selectedThemes.length > 0) {
      filteredResultArr = filteredResultArr.filter((item) => {
        if (
          item.themeTags?.themeTags?.tag?.some((theme) =>
            selectedThemes.includes(theme.label)
          )
        ) {
          return item;
        }
      });
    }

    if (selectedAuthors.length > 0) {
      filteredResultArr = filteredResultArr.filter((item) => {
        let PERSONTYPE = {
          expert: "authorExpert",
          tourLeader: "authorTourLeader",
          artist: "authorArtist",
        };

        if (
          item[PERSONTYPE[item.authorPersonType]] !== null &&
          selectedAuthors.includes(
            item[PERSONTYPE[item.authorPersonType]].title
          )
        ) {
          return item;
        }
      });
    }

    if (selectedRegions.length > 0) {
      // console.log(selectedRegions);
      filteredResultArr = filteredResultArr.filter((item) => {
        if (
          (item.region !== null &&
            selectedRegions.includes(item?.region?.name)) ||
          item?.includedRegions?.some((region) =>
            selectedRegions.includes(region.name)
          )
        ) {
          return item;
        }
      });
    }

    if (selectedHolidayTypes.length > 0) {
      const HOLIDAYTYPE = {
        tailorMadeHoliday: "Tailor-made Holiday",
        culturalTour: "Cultural Tour",
        opera: "Opera",
        hotelBreak: "Hotel Break",
        riverCruise: "River Cruise",
        railJourney: "Rail Journey",
      };
      filteredResultArr = filteredResultArr.filter((item) =>
        selectedHolidayTypes.includes(HOLIDAYTYPE[item._type])
      );
    }

    if (selectedDepartureMonths.length > 0) {
      let resultsWithDarwinDates = filteredResultArr.filter(
        (item) =>
          item._type === "culturalTour" && item.darwinDepartureDates.length > 0
      );
      if (resultsWithDarwinDates.length > 0) {
        let filteredOnlyFutureDates = resultsWithDarwinDates.filter((item) => {
          let datesString = item.darwinDepartureDates.filter(
            (date) =>
              (date.departurestatus === "On Request" ||
                date.departurestatus === "On Sale") &&
              dayjs(date.landonlydeparturedate).isAfter(dayjs())
          );
          if (datesString.length > 0) {
            return item;
          }
        });
        let finalFilterResults = filteredOnlyFutureDates.filter((item) =>
          item.darwinDepartureDates.some((date) =>
            selectedDepartureMonths.includes(
              `${dayjs(date.landonlydeparturedate).format("MMMM")} ${dayjs(
                date.landonlydeparturedate
              ).format("YYYY")}`
            )
          )
        );

        filteredResultArr = finalFilterResults;
      }
    }
   
    if (selectedArtists.length > 0) {
      let selectedArtistsArr = accordionItems
        .find((el) => el.title === "Artists")
        .checkboxes.filter((el) => el.isChecked);

      if (selectedArtistsArr.length > 0) {
        let toursIds = [];
        selectedArtistsArr.map((artist) =>
          artist.tours.map((el) => toursIds.push(el._id))
        );

        filteredResultArr = filteredResultArr.filter(
          (item) => toursIds.length > 0 && toursIds.includes(item._id)
        );
      }
    }

    if (selectedTourLeaders.length > 0) {
      let selectedTourLeadersArr = accordionItems
        .find((el) => el.title === "Tour Leaders")
        .checkboxes.filter((el) => el.isChecked);

      if (selectedTourLeadersArr.length > 0) {
        let toursIds = [];
        selectedTourLeadersArr.map((tourLeader) =>
          tourLeader.tours.map((el) => toursIds.push(el._id))
        );

        filteredResultArr = filteredResultArr.filter(
          (item) => toursIds.length > 0 && toursIds.includes(item._id)
        );
      }
    }

    setTestResults(filteredResultArr);
    setfilteredResults(filteredResultArr);
  };
  const [tags, setTags] = useState([]);
  useEffect(() => {
    testFilterFunction();
    let tagsArr = [];
    accordionItems.map((el) =>
      el.checkboxes.filter(
        (elem) =>
          elem.isChecked === true && tagsArr.push({ ...elem, type: el.title })
      )
    );
    setTags(tagsArr);

    let selectedCountriesArr =
      accordionItems.find((el) => el.title === "Countries") !== undefined &&
      accordionItems
        .find((el) => el.title === "Countries")
        .checkboxes.filter((el) => el.isChecked === true)
        .map((el) => el.name);
  }, [accordionItems]);

  useEffect(() => {
    if (sortBy === "Title (A-Z)") {
      const sortedResults = [...archivePageResults].sort((a, b) =>
        a.title.localeCompare(b.title)
      );
      setArchivePageResults(sortedResults);
    } else if (sortBy === "Title (Z-A)") {
      const sortedResults = [...archivePageResults].sort((a, b) =>
        b.title.localeCompare(a.title)
      );
      setArchivePageResults(sortedResults);
    }
  }, [sortBy]);

  //if we perform search from search-result page
  const resetAllState = () => {
    setArchivePageResults(results);
    setfilteredResults(results);
    setCurrentPage(1);
    setIndexOfLastRecord(currentPage * recordsPerPage);
    setNPages(Math.ceil(results.length / recordsPerPage));
    setCurrentRecords(results.slice(indexOfFirstRecord, indexOfLastRecord));
    setAccordionItems([]);
    setFilterDataLoaded(false);
    setIsInitialLoad(true);
    setSortBy(null);
    setSelectedCheckboxes([]);
    setTestResults(results);
  };

  const removeTag = (tag) => {
    if (tag.type === "Countries") {
      let newTags = tags.filter((el) => {
        if (el.type === "Destinations" && el.country !== tag.name) {
          return el;
        } else if (el.type !== "Destinations") {
          return el;
        }
      });
      setTags(newTags.filter((el) => el.name !== tag.name));
    } else {
      let newTags = tags.filter((el) => el.name !== tag.name);
      // Filtering selectedDeparture to remove clicked date tag and setting the state with new filtered array
      let newSelectedDepartures = selectedDeparture.filter((date)=> date != tag.name)
      setTags(newTags);
      setSelectedDeparture(newSelectedDepartures)
    }

    let newAccordionItems = [...accordionItems];
    newAccordionItems.forEach((item) => {
      if (item.title === tag.type) {
        item.checkboxes.forEach((checkbox) => {
          if (checkbox.name === tag.name) {
            checkbox.isChecked = false;
          }
        });
      }
      if (item.title === "Destinations" && tag.type === "Countries") {
        item.checkboxes.forEach((checkbox) => {
          if (checkbox.country === tag.name) {
            checkbox.isChecked = false;
            // checkbox.visible = false;
          }
        });
      }
    });

    setAccordionItems(newAccordionItems);
  };

  const getMinDate = (el) => {
    let datesArr = [];
    el.darwinDepartureDates.map((date) => {
      if (
        (date.departurestatus === "On Sale" ||
          date.departurestatus === "On Request") &&
        new Date(date.landonlydeparturedate).getTime() > new Date().getTime()
      ) {
        datesArr.push(date);
      }
    });
    if (datesArr.length > 0) {
      let arr2 = [
        ...datesArr.map((date) => new Date(date.landonlydeparturedate)),
      ];

      // Checking if there is any selectedDeparture dates  
      if(selectedDeparture && selectedDeparture.length > 0){

        // Formatting selected date from "December 2025" to "2025-12" 
        let formattedDepartureDate = selectedDeparture.map(
          (dateStr) => new Date(dateStr).getFullYear() + "-" + (new Date(dateStr).getMonth() + 1).toString().padStart(2, '0')
        );

        // Finding the date that matches the selectedDeparture dates
        const minDate = datesArr.find((el) => {
          let elDate = el.landonlydeparturedate.substring(0, 7); // Extracting "YYYY-MM"
          return formattedDepartureDate.includes(elDate); // Checking if it matches
        });

        // Return minDate if found, if undefined return fallback (first valid date)
        return minDate || datesArr[0]; 
      } else {
        let minDate = datesArr.find((el) =>new Date(el.landonlydeparturedate).getTime() === Math.min(...arr2));
        return minDate;
      }
    }
  };
  const getOfferPriceAndDuration = (el) => {
    if (el.darwinDepartureDates?.length > 0) {
      let minDate = getMinDate(el);
      // console.log("minDate", minDate);
      const priceWithoutSingleSupplement = (
        minDate?.landonlyadultprice - minDate?.singlesupplement
      ).toString();
      if (minDate !== undefined && minDate !== null) {
        return `${minDate.landonlyduration} nights from £${
          priceWithoutSingleSupplement.toString().length > 3
          ? priceWithoutSingleSupplement.slice(0, 1) +
          "," +
          priceWithoutSingleSupplement.slice(
            1,
            priceWithoutSingleSupplement.length
          )
          : priceWithoutSingleSupplement
          }pp`;
      }
    }
  };
  // function for blue text on the card
  const getOfferForSearchResultCard = (el) => {
    let minDate = getMinDate(el);

    if (minDate !== undefined && minDate !== null) {
      let MONTHS = {
        1: "January",
        2: "February",
        3: "March",
        4: "April",
        5: "May",
        6: "June",
        7: "July",
        8: "August",
        9: "September",
        10: "October",
        11: "November",
        12: "December",
      };
      let month =
        MONTHS[new Date(Date.parse(minDate.landonlyreturndate)).getMonth() + 1];

      return `${new Date(
        Date.parse(minDate.landonlydeparturedate)
      ).getDate()} - ${new Date(
        Date.parse(minDate.landonlyreturndate)
      ).getDate()} ${month} ${new Date(
        Date.parse(minDate.landonlyreturndate)
      ).getFullYear()}: ${minDate.landonlyduration} nights from £${
        minDate.landonlyadultprice
        // minDate.singlesupplement !== null ? minDate.singlesupplement : minDate.landonlyadultprice
      } per person`;
    }
  };

  const getDepartureMonths = (el) => {
    let futureDates = el.darwinDepartureDates.filter(
      (date) =>
        (date.departurestatus === "On Request" ||
          date.departurestatus === "On Sale") &&
        dayjs(date.landonlydeparturedate).isAfter(dayjs())
    );
    let arr = [];
    let monthsArr = futureDates.map((date) => {
      if (!arr.includes(dayjs(date.landonlydeparturedate).format("MMM")))
        arr.push(dayjs(date.landonlydeparturedate).format("MMM"));
    });

    let months = arr.map((date2, index) => {
      return (
        <div key={`ml-${index}`} className="month-label">
          {date2}
        </div>
      );
    });

    return months;
  };

  const getTourDate = (el) => {
    let minDate = getMinDate(el);
    if (minDate !== undefined && minDate !== null) {
      return dayjs(minDate?.landonlydeparturedate).format("Do MMMM YYYY");
    }
  };

  const [toggleMobileFilters, setToggleMobileFilters] = useState(false);

  useEffect(() => {
    if (!toggleMobileFilters && accordionItems.length > 0) {
      setAccordionItems(
        accordionItems.map((item) => ({
          ...item,
          isOpen: false,
        }))
      );
    }
  }, [toggleMobileFilters]);

  return (
    <ArchivePageStyling className="archive-page">
      {!page?.hero?.heroTitle && (
        <div className="section-title">
          {/* TODO:  If search params - title will be name - search results */}
          {/* <h2>Search Results</h2> */}
          <h2 className="red">{page.name}</h2>
        </div>
      )}
      <div className="search-wrapper">
        <div className="sidebar">
          <div className="sidebar-heading">
            <h5 className="sidebar-heading-title">Filters</h5>
            <p
              className="clear-all-btn"
              role="button"
              onClick={resetAllFilters}
            >
              Clear all
            </p>
          </div>
          <p className="small">{`Showing ${filteredResults.length} of ${results.length}`}</p>

          {accordionItems && accordionItems.length > 0 && (
            <div className="accordion">
              {accordionItems.map((item, index) => (
                <AccordionCheckbox
                  key={index}
                  index={index}
                  content={item}
                  toggleAccordion={toggleAccordion}
                  handleCheckboxChangeAndLog={handleCheckboxChangeAndLog}
                />
              ))}
            </div>
          )}
        </div>

        <div className="mobile-filters">
          <Button
            size="xl"
            btnStyle="outline"
            className=""
            value={"Filters"}
            clickHandler={() => setToggleMobileFilters(!toggleMobileFilters)}
            // isDisabled={false}
          >
            Filters
          </Button>
        </div>
        {toggleMobileFilters && (
          <div className="mobile-filers-wrapper">
            <div
              className="close-filters"
              onClick={() => setToggleMobileFilters(false)}
            >
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_9157_142338)">
                  <path
                    d="M23.7695 10.207L17.6758 16.3008L23.7188 22.3438C24.2266 22.8008 24.2266 23.5625 23.7188 24.0195C23.2617 24.5273 22.5 24.5273 22.043 24.0195L15.9492 17.9766L9.90625 24.0195C9.44922 24.5273 8.6875 24.5273 8.23047 24.0195C7.72266 23.5625 7.72266 22.8008 8.23047 22.293L14.2734 16.25L8.23047 10.207C7.72266 9.75 7.72266 8.98828 8.23047 8.48047C8.6875 8.02344 9.44922 8.02344 9.95703 8.48047L16 14.5742L22.043 8.53125C22.5 8.02344 23.2617 8.02344 23.7695 8.53125C24.2266 8.98828 24.2266 9.75 23.7695 10.207Z"
                    fill="#333333"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_9157_142338">
                    <rect width="32" height="32" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <div className="heading">FILTERS</div>
            <p className="small">{`Showing ${filteredResults.length} of ${results.length}`}</p>
            <div className="dropdowns-wrapper">
              {accordionItems && accordionItems.length > 0 && (
                <div className="accordion">
                  {accordionItems.map((item, index) => (
                    <AccordionCheckbox
                      key={index}
                      index={index}
                      content={item}
                      toggleAccordion={toggleAccordion}
                      handleCheckboxChangeAndLog={handleCheckboxChangeAndLog}
                    />
                  ))}
                </div>
              )}
            </div>
          </div>
        )}

        <div className="results-wrapper">
          <div className="result-wrapper-header">
            <div className="current-search-tags">
              {tags.map((el, index) => {
                let content = el.name;
                if (el.type === "Star Rating") {
                  content = `${el.name}-star`;
                }
                return (
                  <div className="tag-wrapper" key={index}>
                    {content}
                    <div className="reset-tag" onClick={() => removeTag(el)}>
                      <svg
                        width="20"
                        height="24"
                        viewBox="0 0 20 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M14.7812 8.28125L11.0312 12.0312L14.75 15.75C15.0625 16.0312 15.0625 16.5 14.75 16.7812C14.4688 17.0938 14 17.0938 13.7188 16.7812L9.96875 13.0625L6.25 16.7812C5.96875 17.0938 5.5 17.0938 5.21875 16.7812C4.90625 16.5 4.90625 16.0312 5.21875 15.7188L8.9375 12L5.21875 8.28125C4.90625 8 4.90625 7.53125 5.21875 7.21875C5.5 6.9375 5.96875 6.9375 6.28125 7.21875L10 10.9688L13.7188 7.25C14 6.9375 14.4688 6.9375 14.7812 7.25C15.0625 7.53125 15.0625 8 14.7812 8.28125Z"
                          fill="#333333"
                        />
                      </svg>
                    </div>
                  </div>
                );
              })}
            </div>
            <SortByDropdown selected={sortBy} sortByHandler={sortByHandler} />
          </div>
          <Separator color="red" />
          <div className="results">
            {archivePageResults.length > 0 ? (
              archivePageResults.map((card, index) => {
                let tags = [];
                if (card.themeTags !== null && card.themeTags !== undefined) {
                  if (
                    card.themeTags.themeTags !== null &&
                    card.themeTags !== undefined
                  ) {
                    if (card.themeTags.themeTags.tag.length > 0) {
                      card.themeTags.themeTags.tag.map((tag) => {
                        tags.push(tag.label);
                      });
                    }
                  }
                }
                if (tags.length > 0) tags.flat();

                // Adding this as will be making all Archive pages use same component
                const className = `${
                  card._type === "culturalTour"
                    ? " orange-bg"
                    : card._type === "tailorMadeHoliday" ||
                      card._type === "opera" ||
                      card._type === "hotelBreak" ||
                      card._type === "railJourney"
                    ? " red-bg"
                    : ""
                }`;
                // Some cards have one location, some have an array so we either set 'location' or 'locations'
                const location =
                  card.city && card.country
                    ? `${card.city.name}, ${card.country.name}`
                    : card.city
                    ? card.city.name
                    : card.country
                    ? card.country.name
                    : null;

                const locations =
                  card.includedCities && card.includedCities.length > 0
                    ? card.includedCities.map((item) => item.name).join(", ")
                    : null;

                const author = card._type === "review" ? getAuthor(card) : null;

                // TODO: THIS CAN BE REUSABLE COMPONENT?
                let includesIconList;
                if (card._type !== "hotelBreak") {
                  includesIconList =
                    card.includes && card.includes.length > 0
                      ? card.includes.map((item) => {
                          const Icon =
                            item.icon !== null &&
                            item.icon !== undefined &&
                            item.icon !== ""
                              ? renderReactIcon(item.icon.name)
                              : null;
                          return {
                            icon: Icon,
                            title: item.name,
                          };
                        })
                      : null;
                } else {
                  if (
                    card.country.countryIncludes &&
                    card.country.countryIncludes.length > 0
                  ) {
                    includesIconList = card.country.countryIncludes.map(
                      (item) => {
                        const Icon =
                          item.icon !== null &&
                          item.icon !== undefined &&
                          item.icon !== ""
                            ? renderReactIcon(item.icon.name)
                            : null;
                        return {
                          icon: Icon,
                          title: item.name,
                        };
                      }
                    );
                  } else if (
                    card.city.cityIncludes &&
                    card.city.cityIncludes.length > 0
                  ) {
                    includesIconList = card.city.cityIncludes.map((item) => {
                      const Icon =
                        item.icon !== null &&
                        item.icon !== undefined &&
                        item.icon !== ""
                          ? renderReactIcon(item.icon.name)
                          : null;
                      return {
                        icon: Icon,
                        title: item.name,
                      };
                    });
                  }
                }

                const iconsToShow = includesIconList
                  ? includesIconList.slice(0, 4)
                  : null;
                const popoverIcons =
                  includesIconList && includesIconList.length > 4
                    ? includesIconList.slice(4)
                    : [];
                return (
                  <div
                    className={`card-wrapper${className}`}
                    key={`${card._id}-${index}`}
                  >
                    <div className="card">
                      <div className="card-title">
                        {page.cptType === "tourCalendar" && (
                          <div style={{ minWidth: "280px" }}>
                            <p className="tagline">
                              {getCardTagline(card._type)}
                            </p>
                            <p className="card-price">{getTourDate(card)}</p>
                          </div>
                        )}

                        <div className="left">
                          {page.cptType !== "tourCalendar" && (
                            <div className="copies-wrapper">
                                <p className="tagline">{getCardTagline(card._type)}</p>
                                {card.highlyRecommended && (<p className="highly-recommended">Highly Recommended</p>)} 
                            </div>
                          )}
                          <Link to={getSlug(card)}>
                            <h3 className="alt">{card.title}</h3>
                          </Link>
                        </div>
                        <div className="right">
                          {card.darwinDepartureDates &&
                            card.darwinDepartureDates.length > 0 && (
                              <p className="price medium bold">
                                {getOfferPriceAndDuration(card)}
                              </p>
                            )}

                          {card._type === "review" && (
                            <div className="review-info">
                              {card.publishedDate && (
                                <p className="published-date medium">
                                  {getShortDate(card.publishedDate)}
                                </p>
                              )}
                              {author && author.link && (
                                <p className="author">
                                  by{" "}
                                  <span>
                                    <Link to={author.link}>{author.name}</Link>
                                  </span>
                                </p>
                              )}
                            </div>
                          )}
                          {(card.starRating || card.hotelType) && (
                            <div className="ratings">
                              {card.starRating && (
                                <div className="star-rating">
                                  <Stars starRating={card.starRating} />
                                </div>
                              )}
                              {card.hotelType && card.hotelType !== "none" && (
                                <p className="hotel-type bold italic red">
                                  {card.hotelType}
                                </p>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                      <Separator color="grey-thin" />
                      <div className="image-text-content">
                        {card.thumbnail && card.thumbnail.asset ? (
                          !!card.images ? (
                            <div className="img-slider-wrapper">
                              <Swiper
                                slidesPerView={"auto"}
                                // spaceBetween={36}
                                pagination={{
                                  clickable: true,
                                }}
                                navigation={true}
                                modules={[swiperPagination, swiperNavigation]}
                                className="card-carousel-swiper"
                              >
                                {/* {[card.thumbnail, ...card.images] */}
                                {[...card.images]
                                  .slice(0, 10) // limit the images to 10 otherwise pagination design is broken
                                  .map((image, index) => (
                                    <SwiperSlide
                                      key={`im-sl-${card.title}-${index}`}
                                    >
                                     <Link to={getSlug(card)}>
                                        <GatsbyImage
                                          image={getImage(image.asset)}
                                          alt={card.title}
                                          className="accordion-title-img"
                                        />
                                      </Link>
                                    </SwiperSlide>
                                  ))}
                              </Swiper>
                            </div>
                          ) : (
                            <Link to={getSlug(card)}>
                              <GatsbyImage
                                image={getImage(card.thumbnail.asset)}
                                alt={card.title}
                                className="accordion-title-img"
                              />
                            </Link>
                          )
                        ) : (
                          <Link to={getSlug(card)}>
                            <img
                              src={randomPlaceholderImage}
                              alt={card.title}
                              className="placeholder-img"
                            />
                          </Link>
                        )}
                        <div className="content">
                          {/* {(card.country && card.country.name) && (
													<p className="medium">{(card.city && card.city.name) && `${card.city.name}, `}{`${card.country.name}`}</p>
												)} */}
                          {location ||
                            (locations && (
                              <p className="location medium bold">
                                {location || locations}
                              </p>
                            ))}
                          <p className="medium-excerpt">{card.excerpt}</p>
                          {card.specialOffer && (
                            <div className="special-offer">
                              <p className="offer">
                                <span className="badge small bold">
                                  Special Offer
                                </span>
                                {card.specialOffer}
                              </p>
                            </div>
                          )}
                          <Link to={getSlug(card)} className="read-more-btn">
                            <TextButton
                              size="md"
                              className=""
                              value={"Read More"}
                              clickHandler={false}
                              isDisabled={false}
                            />
                          </Link>
                          {card._type === "review" && (
                            <RelatedTripsLocations
                              relatedTrip={card.relatedTrip}
                              relatedLocations={card.relatedLocations}
                            />
                          )}
                          {/* blue text on the card with dates and price */}
                          {/* {card.darwinDepartureDates &&
                            card.darwinDepartureDates.length > 0 && (
                              <p className="special-offer">
                                {getOfferForSearchResultCard(card)}
                              </p>
                            )} */}
                          {card._type === "culturalTour" ? (
                            <div className="tags-wrapper">
                              <div className="single-tag-wrapper">
                                {tags.length > 0 &&
                                  tags
                                    .map((tag, index) => {
                                      return tag;
                                    })
                                    .join(", ")}
                              </div>

                              {card.darwinDepartureDates &&
                                card.darwinDepartureDates.length > 0 && (
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "row",
                                      gap: "8px",
                                    }}
                                  >
                                    {getDepartureMonths(card)}
                                  </div>
                                )}
                            </div>
                          ) : (
                            card.darwinDepartureDates &&
                            card.darwinDepartureDates.length > 0 && (
                              <p className="special-offer">
                                {getOfferForSearchResultCard(card)}
                              </p>
                            )
                          )}
                        </div>
                        <div className="includes">
                          {iconsToShow && iconsToShow.length > 0 && (
                            <div className="included-items">
                              <IconList
                                iconListItems={iconsToShow}
                                iconLayout="minimal"
                                addPopover={true}
                                popoverListItems={popoverIcons}
                                id={`${card._id}-${index}`}
                                addText={true}
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <Separator color="red" />
                  </div>
                );
              })
            ) : (
              <div className="card-wrapper">
                <h6>No results match</h6>
                <Separator color="red" />
              </div>
            )}
          </div>
        </div>
      </div>
      {nPages > 1 && (
        <Pagination
          nPages={nPages}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      )}
    </ArchivePageStyling>
  );
};

export default ArchiveContent;
